import React from 'react';

import { FaMapLocationDot } from 'react-icons/fa6';
import { IoIosMail, IoIosArrowBack } from 'react-icons/io';
import whiteLogo from '../../Asset/Imgs/logo.png';

import { FaPhoneVolume, FaTiktok } from 'react-icons/fa';
import { FaFacebookF } from 'react-icons/fa6';
import { PiInstagramLogo } from 'react-icons/pi';
import { RiSnapchatFill } from 'react-icons/ri';
import { FaXTwitter } from 'react-icons/fa6';
import { FiExternalLink } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { ContactInfoThunk } from '../../RTK/Thunk/ContactInfoThunk';
import { SocialLinksThunk } from '../../RTK/Thunk/SocialLinksThunk';

const Footer = () => {
	const dispatch = useDispatch();
	const { contactInfo } = useSelector(state => state.ContactInfoReducer);
	const { socialLinks } = useSelector(state => state.SocialLinksReducer);
	const { siteLogo } = useSelector(state => state.SiteLogoReducer);
	const { websiteMapPages, quickLinksPages } = useSelector(
		state => state.PagesReducer,
	);

	const getDataRef = React.useRef(true);
	React.useEffect(() => {
		if (getDataRef.current) {
			getDataRef.current = false;
			dispatch(ContactInfoThunk());
			dispatch(SocialLinksThunk());
		}
	}, [getDataRef]);

	// social media links
	const socialLinksItems = socialLinks?.map(item => (
		<li key={item}>
			<a
				className='rounded-full border-[1px] group flex justify-center items-center !w-[40px] !h-[40px] p-1 group hover:border-color_03 border-color_06 transition-all duration-300 hover:scale-110 hover:shadow-lg'
				href={item}
				target='_blank'
				rel='noopener noreferrer'>
				{item?.includes('facebook') ? (
					<FaFacebookF className='group-hover:!text-[24px] !w-[50px] transition-all duration-300 group-hover:text-color_03 text-color_06 !text-[20px]' />
				) : item?.includes('twitter') ? (
					<FaXTwitter className='group-hover:!text-[24px] !w-[50px] transition-all duration-300 group-hover:text-color_03 text-color_06 !text-[20px]' />
				) : item?.includes('snapchat') ? (
					<RiSnapchatFill className='group-hover:!text-[24px] !w-[50px] transition-all duration-300 group-hover:text-color_03 text-color_06 !text-[20px]' />
				) : item?.includes('tiktok') ? (
					<FaTiktok className='group-hover:!text-[24px] !w-[50px] transition-all duration-300 group-hover:text-color_03 text-color_06 !text-[20px]' />
				) : item?.includes('instagram') ? (
					<PiInstagramLogo className='group-hover:!text-[24px] !w-[50px] transition-all duration-300 group-hover:text-color_03 text-color_06 !text-[20px]' />
				) : (
					<FiExternalLink className='group-hover:!text-[24px] !w-[50px] transition-all duration-300 group-hover:text-color_03 text-color_06 !text-[20px]' />
				)}
			</a>
		</li>
	));

	/** pages */
	const websiteMapPagesLinks = websiteMapPages?.map(page => (
		<div className='group mb-2' key={page?.id}>
			<h6 className='flex justify-start items-center gap-[8px] group-hover:mr-[8px] text-color_04 hover:text-color_03 transition-all duration-300 cursor-pointer text-[16px] font-medium py-1'>
				<span className='transition-transform duration-300 group-hover:translate-x-1'>
					<IoIosArrowBack />
				</span>
				<span>{page?.name}</span>
			</h6>
			<div className='group-hover:w-[95%] transition-all duration-300 w-0 h-[2px] mr-[8px] bg-gradient-to-r from-color_03 to-color_04 rounded-full'></div>
		</div>
	));

	const quickLinksPagesLinks = quickLinksPages?.map(page => (
		<div className='group mb-2' key={page?.id}>
			<h6 className='flex justify-start items-center gap-[8px] group-hover:mr-[8px] text-color_04 hover:text-color_03 transition-all duration-300 cursor-pointer text-[16px] font-medium py-1'>
				<span className='transition-transform duration-300 group-hover:translate-x-1'>
					<IoIosArrowBack />
				</span>
				<span>{page?.name}</span>
			</h6>
			<div className='group-hover:w-[95%] transition-all duration-300 w-0 h-[2px] mr-[8px] bg-gradient-to-r from-color_03 to-color_04 rounded-full'></div>
		</div>
	));

	return (
		<footer className='pb-[10px] bg-main_color_08 h-full bg-color_08 pt-[60px] relative overflow-hidden'>
			{/* Background Pattern */}
			<div className='absolute inset-0 opacity-5'>
				<div className='absolute top-10 left-10 w-32 h-32 border border-color_04 rounded-full'></div>
				<div className='absolute bottom-20 right-20 w-24 h-24 border border-color_04 rounded-full'></div>
				<div className='absolute top-1/2 left-1/3 w-16 h-16 border border-color_04 rounded-full'></div>
			</div>

			<div className='container relative z-10'>
				<div className='flex max-lg:flex-col-reverse justify-between gap-[60px] items-start'>
					<div className='flex gap-[50px] max-xl:gap-[30px] max-lg:flex-col justify-start flex-1 items-start'>
						{/* Logo and Social Media Section */}
						<div className='flex-1 max-lg:text-center'>
							<div
								style={{ direction: 'rtl' }}
								className='box-info gap-[12px] flex flex-col justify-start items-start max-lg:items-center text-start max-lg:text-center'>
								<div className='box-img w-[160px] h-[90px] mb-4'>
									<img
										src={whiteLogo}
										alt='Logo'
										className='w-full h-full object-contain filter drop-shadow-lg'
									/>
								</div>
								<p className='text-color_04 text-sm leading-relaxed mb-4 max-w-[250px]'>
									جمعية أهلية متخصصة في المسرح والفنون الأدائية في المملكة
									العربية السعودية ،تحت إشراف المركز الوطني لتنمية القطاع الغير
									ربحي
								</p>
								<ul className='link_footer flex justify-start max-lg:justify-center items-center gap-[12px] mt-2'>
									{socialLinksItems}
								</ul>
							</div>
						</div>

						{/* Website Map Section */}
						<div className='flex-1'>
							<div
								style={{ direction: 'rtl' }}
								className='box-info gap-[8px] flex flex-col justify-start items-start text-start'>
								<h4 className='text-color_04 transition-all duration-300 font-bold text-xl mb-4 pb-2 border-b-2 border-color_03/30'>
									خريطة الموقع
								</h4>
								<div className='space-y-1'>{websiteMapPagesLinks}</div>
							</div>
						</div>

						{/* Quick Links Section */}
						<div className='flex-1'>
							<div
								style={{ direction: 'rtl' }}
								className='box-info w-full gap-[8px] flex flex-col justify-start items-start text-start'>
								<h4 className='text-color_04 transition-all duration-300 font-bold text-xl mb-4 pb-2 border-b-2 border-color_03/30'>
									الروابط السريعة
								</h4>
								<div className='space-y-1'>{quickLinksPagesLinks}</div>
							</div>
						</div>

						{/* Contact Section */}
						<div className='flex-1'>
							<div
								style={{ direction: 'rtl' }}
								className='box-info w-full gap-[8px] flex flex-col justify-start items-start text-start'>
								<h4 className='text-color_04 transition-all duration-300 font-bold text-xl mb-4 pb-2 border-b-2 border-color_03/30'>
									تواصل معنا
								</h4>
								<div className='space-y-3'>
									<div className='group hover:bg-color_06/10 p-2 rounded-lg transition-all duration-300'>
										<h6 className='flex justify-start items-center gap-[8px] text-color_04 text-[16px] font-medium'>
											<span className='text-color_03 text-lg'>
												<FaMapLocationDot />
											</span>
											<span className='leading-relaxed'>
												{contactInfo?.address}
											</span>
										</h6>
									</div>
									<div className='group hover:bg-color_06/10 p-2 rounded-lg transition-all duration-300'>
										<h6 className='flex justify-start items-center gap-[8px] text-color_04 text-[16px] font-medium'>
											<span className='text-color_03 text-lg'>
												<FaPhoneVolume />
											</span>
											<span className='leading-relaxed'>
												{contactInfo?.phone}
											</span>
										</h6>
									</div>
									<div className='group hover:bg-color_06/10 p-2 rounded-lg transition-all duration-300'>
										<h6 className='flex justify-start items-center gap-[8px] text-color_04 text-[16px] font-medium'>
											<span className='text-color_03 text-lg'>
												<IoIosMail />
											</span>
											<span className='leading-relaxed'>
												{contactInfo?.email}
											</span>
										</h6>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Divider */}
				<div className='w-full h-[2px] mt-12 mb-6 bg-gradient-to-r from-transparent via-color_11 to-transparent rounded-full'></div>

				{/* Copyright Section */}
				<div className='flex flex-col items-center gap-3'>
					<h6 className='flex flex-wrap w-full justify-center items-center gap-[5px] text-color_03 text-[14px] font-normal'>
						<span>جميع الحقوق محفوظة لدينا 2023</span> | تم التنفيذ من قبل
						<a
							href='https://layersads.com'
							target='_blank'
							rel='noopener noreferrer'
							className='text-white hover:text-color_03 transition-all duration-300 font-bold'>
							وكالة لايرز للتسويق والإعلان
						</a>
					</h6>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
